export default __webpack_public_path__ + "media/images/front/snsBnr/pc_sns_close-8d501be70389f25e95f9b0c3f2c6c355.png";